<template>
  <div class="grid-view tab-change-charge">
    <query-change-charge-bpm
      ref="queryChangeCharge"
      identify="queryChangeCharge"
      view-source="tabChangeChargeBpm"
      :state="searchConditionsState"
      :input-date-start="searchConditions.inputDateStart"
      :input-date-end="searchConditions.inputDateEnd"
      config-module="5111"
      grid-config-module="1911011"
      @rowDoubleClicked="rowDoubleClicked"
      @showDetailClicked="showDetailHandler"
    >
      <div slot="operations">
        <el-button v-show="[2].includes(applicationStatus)" type="primary" no="1" @click="editAccountingDateHandler">{{ $t('CargoMsg.Cargo_EditFinancialDate') }}</el-button>
        <el-button type="primary" no="8" @click="toPrint">{{ $t('Payment.print') }}</el-button>
      </div>
      <template v-slot:other>
        <el-form :inline="true" label-width="60px" label-position="left" style="margin-right: 15px;">
          <el-form-item :label="$t('ChangeCharge.dateCreated')" class="el-form-item-search">
            <el-row>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateStart"
                    type="date"
                    style="margin-right: 0px;"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    no="10"
                  /></el-form-item>
              </el-col>
              <el-col :span="2"><span>{{ $t('Billing.billingJob_dateTo') }}</span></el-col>
              <el-col :span="8">
                <el-form-item label-width="0">
                  <el-date-picker
                    v-model="searchConditions.inputDateEnd"
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    no="11"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-checkbox v-model="allowTwoYearOutside" no="12">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </template>
    </query-change-charge-bpm>
    <!-- 修改财务审核日期弹窗 -->
    <el-dialog
      :visible.sync="accountingDateDialog.visible"
      :title="$t('CargoMsg.Cargo_EditFinancialDate')"
      :close-on-click-modal="false"
      :show-close="false"
      width="330px"
    >
      <div class="main-content">
        <div style="width: fit-content">
          <div style="display: flex">
            <div class="section form-column" style="min-width: 310px">
              <el-form
                label-width="75px"
                style="margin: 20px;"
                label-position="left"
              >
                <el-form-item style="font-size: 14px; margin: 20px" :label="$t('CargoMsg.Cargo_FinancialDate')">
                  <div style="display: flex;">
                    <el-date-picker
                      v-model="accountingDateDialog.accountingDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="flex: 1;width: 80px"
                      :clearable="false"
                      no="22"
                      :picker-options="pickerOptions"
                    />
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="24" @click="editAccountingDateConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="25" @click="dialogCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 更改前后对比弹窗 -->
    <before-and-after-comparison-dialog-bpm
      v-if="beforeAndAfterComparisonDialogBpm.visible"
      :visible.sync="beforeAndAfterComparisonDialogBpm.visible"
      :tips="false"
      :change-reason="beforeAndAfterComparisonDialogBpm.changeReason"
      :ar-charge-before="beforeAndAfterComparisonDialogBpm.arChargeBefore"
      :ap-charge-before="beforeAndAfterComparisonDialogBpm.apChargeBefore"
      :ar-charge-after="beforeAndAfterComparisonDialogBpm.arChargeAfter"
      :ap-charge-after="beforeAndAfterComparisonDialogBpm.apChargeAfter"
      :charge-original-profit="beforeAndAfterComparisonDialogBpm.chargeOriginalProfit"
      :charge-change-profit="beforeAndAfterComparisonDialogBpm.chargeChangeProfit"
      :ap-tip="beforeAndAfterComparisonDialogBpm.apTip"
      :ar-tip="beforeAndAfterComparisonDialogBpm.arTip"
      @onCancel="() => { beforeAndAfterComparisonDialogBpm.visible = false }"
    />
    <!-- 打印弹窗 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import queryChangeChargeBpm from '@/views/cargo/v0/Clearing/components/query/queryChangeChargeBpm'
import moment from 'moment'
import { getLoading } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import beforeAndAfterComparisonDialogBpm from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/beforeAndAfterComparisonDialogBpm'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import { submitDataByPost } from '@/utils/commonUtil'
import {
  CHANGE_CHARGE_AWAIT_AUDIT, CHANGE_CHARGE_AWAIT_DONE
  , CHANGE_CHARGE_STATES_BPM_ALL_CODES

} from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { batchUpdateAccountingDateBpm, getChangeChargeBpm } from '@/api/clearing/changeChargeBpm'

export default {
  name: 'TabChangeChargeBpm',
  components: { CargoTemplateSelectDialog, queryChangeChargeBpm, beforeAndAfterComparisonDialogBpm },
  props: {
    applicationStatus: { type: Number, default: 0 } // 申请进度:1=待判责审核;2=待商务审核;3=待关账判定;4=已生效;5=已拒绝;6=已撤销申请;7=待经理审核 bpm状态值： 21-未审批;22-审批中;23-已审批;24-已废弃;
  },
  data() {
    return {
      loading: false,
      searchConditions: {
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'), // 付款申请日期
        inputDateEnd: ''
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      applyChangeChargeTab: 0, // 审核流程配置参数
      inputIncludingTaxUnitPrice: 0, // 单价是否含税
      hasJudgeDuty: false, // 是否判责审核权限
      hasBusinessAudit: false, // 是否商务审核权限
      hasJudgeClosed: false, // 是否关账判定权限
      hasRevoke: false, // 是否撤销申请权限
      allowTwoYearOutside: false,
      // 关账判定弹窗
      accountingDateDialog: {
        visible: false,
        accountingDate: moment(new Date()).format('yyyy-MM-DD') // 财务日期
      },
      templateSelectorDialog: { // 打印
        visible: false,
        cxt: null,
        category: 'CHANGE_CHARGE',
        data: {
          CHANGE_CHARGE_LIST_UUID: []
        }
      },
      // 更改前后对比
      beforeAndAfterComparisonDialogBpm: {
        visible: false,
        apTip: '',
        arTip: '',
        changeReason: '', // 更改原因
        arChargeBefore: [], // 修改前
        apChargeBefore: [], // 修改前
        arChargeAfter: [], // 修改后,
        apChargeAfter: [], // 修改后,
        chargeOriginalProfit: [], // 整票预估利润：修改前
        chargeChangeProfit: [] // 整票预估利润：修改后
      },
      isDirectModify: false // 更改费用审核费用调整模式 （1=调整模式，默认；2=直接更改）
    }
  },
  computed: {
    searchConditionsState() {
      switch (this.applicationStatus) {
        case 0: return CHANGE_CHARGE_STATES_BPM_ALL_CODES // 全部
        case 1: return [CHANGE_CHARGE_AWAIT_AUDIT.code] // 审批中
        case 2: return [CHANGE_CHARGE_AWAIT_DONE.code] // 已完成
        default: return []
      }
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Billing.billingJob_unlockBillPaymentDateQuery'), this.$t('Message.Prompt'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    }
  },
  async created() {
    this.hasJudgeDuty = this.$checkPermission(['button_ChangeChargeVerify_btnJudgeDuty'])
    this.hasBusinessAudit = this.$checkPermission(['button_ChangeChargeVerify_btnBusinessAudit'])
    this.hasJudgeClosed = this.$checkPermission(['button_ChangeChargeVerify_btnJudgeClosed'])
    this.hasRevoke = this.$checkPermission(['button_ChangeChargeVerify_btnRevoke'])
    await cache.load(cacheName.CONFIG)
    this.applyChangeChargeTab = Number(cache.config.get('applyChangeChargeTab'))
    // CARGO-4980 单价是否含税
    this.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
    // CARGO-24840，申请更改费用/申请删除费用时直接在原费用上做调整
    this.isDirectModify = parseInt(cache.config.get('ChangeChargeJudgeClosedType')) === 2
  },
  methods: {
    // 重新加载列表数据
    reloadData() {
      this.$refs.queryChangeCharge.toQueryChangeChargeList()
    },
    // 打印按钮触发事件
    toPrint() {
      const chooseRows = this.$refs.queryChangeCharge.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectChargeApplyData'))
        return
      }
      const params = {}
      const keys = []
      for (const changeCharge of chooseRows) {
        if (changeCharge.uuid && keys.indexOf(changeCharge.uuid) < 0) {
          keys.push(changeCharge.uuid)
        }
      }
      params.CHANGE_CHARGE_LIST_UUID = keys
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'CHANGE_CHARGE'
      this.templateSelectorDialog.visible = true
    },
    exportHandler() {
      const chooseRows = this.$refs.queryChangeCharge.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExportChargeDetailData'))
        return
      }
      if (chooseRows && chooseRows.length > 5000) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BeyondMaxExportChargeDetailData'))
        return
      }
      const keys = []
      for (const changeCharge of chooseRows) {
        if (changeCharge.uuid && keys.indexOf(changeCharge.uuid) < 0) {
          keys.push(changeCharge.uuid)
        }
      }
      submitDataByPost(URL.act.changeCharge.exportChangeChargeDetail, {
        sessionId: getToken(),
        uuids: keys.join(',')
      })
      this.reloadData()
    },
    // 更改前后对比
    showDetailHandler(changeChargeUuid) {
      if (StrUtils.isEmpty(changeChargeUuid)) return
      const requestBody = { changeChargeKey: changeChargeUuid, branchId: this.$store.getters.currentOfficeId }
      this.loading = getLoading()
      console.log('getChangeChargeBpm', requestBody)
      getChangeChargeBpm(requestBody).then(res => {
        const changeCharge = res.data
        this.beforeAndAfterComparisonDialogBpm.arChargeBefore = []
        this.beforeAndAfterComparisonDialogBpm.apChargeBefore = []
        const originalChargeUuidArMap = new Map()
        const originalChargeUuidApMap = new Map()
        if (changeCharge.chargeOriginals) {
          for (const data of changeCharge.chargeOriginals) {
            if (data.receivable) {
              if (data.uuid && !originalChargeUuidArMap[data.uuid]) {
                originalChargeUuidArMap.set(data.uuid, originalChargeUuidArMap.size + 1)
                data.originalSerialNo = originalChargeUuidArMap.get(data.uuid)
              }
              this.beforeAndAfterComparisonDialogBpm.arChargeBefore.push(data)
            } else {
              if (data.uuid && !originalChargeUuidApMap[data.uuid]) {
                originalChargeUuidApMap.set(data.uuid, originalChargeUuidApMap.size + 1)
                data.originalSerialNo = originalChargeUuidApMap.get(data.uuid)
              }
              this.beforeAndAfterComparisonDialogBpm.apChargeBefore.push(data)
            }
          }
        }
        this.beforeAndAfterComparisonDialogBpm.arChargeAfter = []
        this.beforeAndAfterComparisonDialogBpm.apChargeAfter = []
        if (changeCharge.chargeChanges) {
          for (const data of changeCharge.chargeChanges) {
            if (data.receivable) {
              data.originalSerialNo = originalChargeUuidArMap.get(data.originalChargeUuid)
              this.beforeAndAfterComparisonDialogBpm.arChargeAfter.push(data)
            } else {
              data.originalSerialNo = originalChargeUuidApMap.get(data.originalChargeUuid)
              this.beforeAndAfterComparisonDialogBpm.apChargeAfter.push(data)
            }
          }
        }

        // this.beforeAndAfterComparisonDialogBpm.chargeBefore = []
        // if (changeCharge.actionType === 0) this.beforeAndAfterComparisonDialogBpm.chargeBefore.push(changeCharge.chargeOriginal)
        // this.beforeAndAfterComparisonDialogBpm.chargeAfter = []
        // this.beforeAndAfterComparisonDialogBpm.chargeAfter.push(changeCharge.chargeChange)

        this.beforeAndAfterComparisonDialogBpm.changeReason = changeCharge.changeReason
        // 整票预估利润
        this.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit = []
        this.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit = changeCharge.chargeOriginalProfit
        this.beforeAndAfterComparisonDialogBpm.chargeChangeProfit = []
        this.beforeAndAfterComparisonDialogBpm.chargeChangeProfit = changeCharge.chargeChangeProfit
        this.beforeAndAfterComparisonDialogBpm.apTip = changeCharge.apTip
        this.beforeAndAfterComparisonDialogBpm.arTip = changeCharge.arTip
        this.beforeAndAfterComparisonDialogBpm.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    dialogCancel() {
      this.accountingDateDialog.visible = false
    },
    // 编辑财务日期
    editAccountingDateHandler() {
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.accountingDateDialog.judgeClosedResult = '1'
      this.accountingDateDialog.visible = true
    },
    editAccountingDateConfirm() {
      const accountingDate = this.accountingDateDialog.accountingDate
      if (!accountingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckNull'))
        return
      }
      const selections = this.$refs.queryChangeCharge.getSelections()
      if (selections.length === 0) {
        this.dialogCancel()
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      const keys = []
      for (const changeCharge of selections) {
        keys.push(changeCharge.uuid)
      }
      this.loading = getLoading()
      batchUpdateAccountingDateBpm(keys, accountingDate).then(res => {
        this.$message.success(this.$t('Message.FinancialDateModifiedSuccessfully'))
        // 刷新
        this.reloadData()
      }).finally(() => {
        this.loading.close()
        this.dialogCancel()
      })
    },
    // 列表双击事件
    rowDoubleClicked(changeCharge) {
      this.showDetailHandler(changeCharge.uuid)
    },
    disabledDate(currDate) {
      const d = moment(currDate, 'YYYY-MM_DD')
      return d > new Date()
    }
  }
}
</script>

<style lang="scss">
.tab-change-charge {
  .el-form-item-search {
    margin-right: 15px;
    .el-form-item__label {
      padding-right: 5px;
      font-size: 13px !important;
    }
    .el-form-item__content {
      .el-checkbox {
        .el-checkbox__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-input {
        width: 110px;
      }
      .el-input__inner {
        padding-left: 20px !important;
        padding-right: 5px !important;
        width: 110px;
      }
    }
  }
}
</style>
